import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-device-export-data",
  "use": "app-icon-device-export-data-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"app-icon-device-export-data\"><g fill=\"#6C92FA\" fill-rule=\"evenodd\"><path d=\"M20.5 8.625v1.25h4.651l-6.95 6.416.848.919 7.076-6.532v4.197h1.25v-6.25z\" /><path d=\"M8.625 8.625v18.75h18.75v-10h-1.25v8.75H9.875V9.875H18v-1.25z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol